import { ExternalAccount } from '@features/accounts/types';
import { api } from '@src/lib/api-client';
import { QueryConfig } from '@src/lib/react-query';
import { queryOptions, useQuery } from '@tanstack/react-query';

export type GetExternalAccountsResponse = ExternalAccount[];

export async function getExternalAccounts(): Promise<GetExternalAccountsResponse> {
  return await api
    .get<GetExternalAccountsResponse>(`/api/v3/user/accounts/external`)
    .then((res) => res.data);
}

export const getExternalAccountsQueryOptions = queryOptions({
  queryKey: ['externalAccounts', 'list'],
  queryFn: getExternalAccounts,
  throwOnError: false,
});

type UseGetExternalAccountsOptions = {
  queryConfig?: QueryConfig<typeof getExternalAccountsQueryOptions>;
};

export const useGetExternalAccounts = ({
  queryConfig,
}: UseGetExternalAccountsOptions = {}) => {
  return useQuery({
    ...getExternalAccountsQueryOptions,
    ...queryConfig,
  });
};
